export interface TomoItem {
  emoji: string;
  title: string;
  content: string;
}

export const TOMOS: TomoItem[] = [
  {
    emoji: "🧭",
    title: "TOMO 1 — EVALUACIÓN INICIAL Y POSIBLE DERECHO",
    content: `Objetivo
Entender cómo funciona hoy la ciudadanía por descendencia y evaluar tu caso antes de gastar en documentación.

Capítulos clave
• Iure sanguinis y reconocimiento de ciudadanía.
• Reforma italiana de 2025 y situaciones transitorias.
• Construcción de la línea familiar.
• Naturalización, línea materna y casos de 1948.
• Pérdida de ciudadanía, hijos menores y vías alternativas.
• Test de evaluación preliminar.

Resultado
Un mapa de tu línea familiar, datos faltantes y próximos pasos.`,
  },
  {
    emoji: "🌳",
    title: "TOMO 2 — INVESTIGACIÓN GENEALÓGICA",
    content: `Objetivo
Encontrar al ascendiente italiano correcto y transformar recuerdos familiares en una línea documentada.

Capítulos clave
• Cómo iniciar la búsqueda y entrevistar a la familia.
• Fichas por persona y variantes de nombres.
• Registros argentinos, FamilySearch y Portale Antenati.
• Registros parroquiales e identificación del comune.
• Línea de tiempo familiar y control de datos.

Resultado
Árbol documentado, fichas de cada generación y fuentes organizadas.`,
  },
  {
    emoji: "📜",
    title: "TOMO 3 — PARTIDAS Y DOCUMENTACIÓN",
    content: `Objetivo
Solicitar, verificar y clasificar los documentos italianos y argentinos del expediente.

Capítulos clave
• Inventario documental por generación.
• Solicitud de partidas italianas y argentinas.
• Modelos de correos para comune, parroquias y archivos.
• Certificado de naturalización.
• Apostillas, traducciones y rectificaciones.
• Revisión y archivo digital del expediente.

Resultado
Una carpeta documental clara, revisada y lista para avanzar.`,
  },
  {
    emoji: "🗂️",
    title: "TOMO 4 — ARMADO DEL EXPEDIENTE",
    content: `Objetivo
Ordenar todos los documentos en un expediente coherente y fácil de revisar.

Capítulos clave
• Orden generacional y documentos complementarios.
• Matriz de coherencia de nombres, fechas y lugares.
• Semáforo documental: verde, amarillo y rojo.
• Formularios, identidad y jurisdicción consular.
• Expedientes de familiares reconocidos.
• Auditoría final antes de presentar.

Resultado
Un expediente ordenado con alertas claras sobre lo que falta revisar.`,
  },
  {
    emoji: "🏛️",
    title: "TOMO 5 — PRESENTACIÓN Y SEGUIMIENTO",
    content: `Objetivo
Prepararte para presentar el caso en consulado o Italia sin promesas de turnos ni plazos.

Capítulos clave
• Presentación consular en Argentina.
• Uso seguro de Prenot@mi.
• Documentación y preparación para el día del turno.
• Seguimiento responsable del expediente.
• Reconocimiento en Italia y elección del comune.
• Gestores, profesionales y comparación de vías.

Resultado
Un plan de presentación realista, organizado y seguro.`,
  },
  {
    emoji: "🎉",
    title: "TOMO 6 — DESPUÉS DEL RECONOCIMIENTO",
    content: `Objetivo
Conocer los trámites que siguen una vez reconocido como ciudadano italiano.

Capítulos clave
• Confirmación y corrección de datos en el comune.
• Inscripción y actualización en AIRE.
• Solicitud del pasaporte italiano.
• Codice fiscale.
• Documentación de hijos y familiares.
• Derechos y responsabilidades como ciudadano de la Unión Europea.

Resultado
Una hoja de ruta para mantener tu documentación italiana al día.`,
  },
];

export interface BonoItem {
  emoji: string;
  title: string;
  content: string;
}

export const BONOS: BonoItem[] = [
  {
    emoji: "✅",
    title: "BONO 1 — Checklist Maestro del Expediente Italiano",
    content: "Incluye evaluación preliminar, árbol genealógico, partidas, naturalización, apostillas, traducciones, rectificaciones, turno, presentación, AIRE y pasaporte. Cada elemento permite registrar estado, prioridad, responsable, fechas y observaciones.",
  },
  {
    emoji: "📊",
    title: "BONO 2 — Excel Organizador del Expediente",
    content: "Pestañas de resumen, árbol familiar, personas, documentos, costos, inconsistencias, turnos y seguimiento. Incluye semáforo de estado, avance, alertas y filtros por generación.",
  },
  {
    emoji: "🔗",
    title: "BONO 3 — Directorio de Fuentes Oficiales",
    content: "Enlaces organizados a consulados, embajada, ministerios, Portale Antenati, archivos, registros civiles, apostilla, colegios de traductores y plataformas italianas oficiales.",
  },
  {
    emoji: "✉️",
    title: "BONO 4 — Pack de Modelos de Solicitud",
    content: "Modelos para pedir partidas, hacer búsquedas sin fecha exacta, consultar parroquias, archivos, comune, traductores y profesionales.",
  },
  {
    emoji: "📅",
    title: "BONO 5 — Cronograma Personalizable de 12 Meses",
    content: "Planifica investigación, actas, naturalización, rectificaciones, apostillas, traducciones, auditoría, presentación y seguimiento en escenarios simples o complejos.",
  },
  {
    emoji: "⚠️",
    title: "BONO 6 — Guía de los 50 Errores Más Frecuentes",
    content: "Errores frecuentes de elegibilidad, genealogía, partidas, nombres, fechas, apostillas, traducciones, turnos, gestores, AIRE y pasaporte.",
  },
];
